// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2296":"d320d05e","3434":"d320d05e","3799":"d320d05e","3932":"d320d05e","4364":"e18a9a6a","9835":"d320d05e"}[chunkId] + ".chunk.css";
};